<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__nbbankfiles}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{
            $t("export")
          }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="$hasPermission('sys:nbbankfiles:save')"
            type="primary"
            @click="addOrUpdateHandle()"
            >{{ $t("add") }}</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="$hasPermission('sys:nbbankfiles:delete')"
            type="danger"
            @click="deleteHandle()"
            >{{ $t("deleteBatch") }}</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
      >
        <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="id"
          label="主键id"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="limitApply"
          label="申请编号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="customerName"
          label="企业名称"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="channelNum"
          label="渠道号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="limitStatus"
          label="授信状态"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="applyTime"
          label="申请时间"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="limitTime"
          label="授信时间"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="limitAmount"
          label="授信额度"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="limitEndTime"
          label="额度到期日"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="yrymInvitationCode"
          label="推荐官邀请码"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="yrymCaptainCode"
          label="团队长邀请码"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="yrymAdminCode"
          label="管理员邀请码"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="timeDemand"
          label="时长是否满足要求"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="amountDemand"
          label="金额是否满足要求"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="drawMoneyDemand"
          label="提款是否满足要求"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="creator"
          label="创建者"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createDate"
          label="创建时间"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="efficientAmount"
          label="生效额度"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="$t('handle')"
          fixed="right"
          header-align="center"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <el-button
              v-if="$hasPermission('sys:nbbankfiles:update')"
              type="text"
              size="small"
              @click="addOrUpdateHandle(scope.row.id)"
              >{{ $t("update") }}</el-button
            >
            <el-button
              v-if="$hasPermission('sys:nbbankfiles:delete')"
              type="text"
              size="small"
              @click="deleteHandle(scope.row.id)"
              >{{ $t("delete") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update
        v-if="addOrUpdateVisible"
        ref="addOrUpdate"
        @refreshDataList="getDataList"
      ></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import AddOrUpdate from "./nbbankfiles-add-or-update";
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/sys/nbbankfiles/page",
        getDataListIsPage: true,
        exportURL: "/sys/nbbankfiles/export",
        deleteURL: "/sys/nbbankfiles",
        deleteIsBatch: true,
      },
      dataForm: {
        id: "",
      },
    };
  },
  components: {
    AddOrUpdate,
  },
};
</script>
